import { NgModule } from "@angular/core";
import { AppStatusComponent } from "./AppStatus.component";
import { CommonModule } from "@angular/common";
import {ProgressBarModule} from "../progressBarModule/progressBar.module";

@NgModule({
	imports: [
		CommonModule,
		ProgressBarModule
	],
    declarations: [
        AppStatusComponent
    ],
    exports: [
        AppStatusComponent
    ],
    providers: [],
    bootstrap: []
})
export class AppStatusModule { }
